


























































































import { tableComposition } from '@/compositions/table'
import { defineComponent } from '@vue/composition-api'
import {
  createRemittanceBalanceCharge,
  createRemittanceBalancePayment,
  remittanceBalanceController,
} from '~/api/Remittances/remittances.api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import IconButton from '~/components/IconButton.vue'
import BalancesFilter from '~/components/Services/Remittances/BalancesFilter.vue'
import BalanceCrudDialog from '~/components/Services/Remittances/Remittance/BalanceCrudDialog.vue'
import TransferBalanceDialog from '~/components/Services/Remittances/TransferBalanceDialog.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import TextButton from '~/components/TextButton.vue'

export default defineComponent({
  components: {
    TransferBalanceDialog,
    IconButton,
    BalanceCrudDialog,
    TableSwitch,
    BalancesFilter,
    FlatCard,
    FlatTable,
    TextButton,
  },
  setup: () => {
    return {
      ...tableComposition(remittanceBalanceController),
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('agency.agency'),
          value: 'agency_name',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
    }
  },
  methods: {
    charge: createRemittanceBalanceCharge,
    pay: createRemittanceBalancePayment,
  },
})
